import React, { Component } from "react";
import { withApollo } from "react-apollo";
import { Queries, Mutations } from "../../../../../../graphql";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Typography, Row, Col, Form, Table } from "antd";
import FromInput from "../../../../../../components/user/from/Input";
import { numberWithCommas } from "../../../../../../utils/number";
import { changeFormatdate } from "../../../../../../utils/formatdate";
const { Text, Title } = Typography;

class WelfareListStudyPaymentInScholarshipDetail extends Component {
  state = {
    loading: false,
    loadingFullpage: true,
    columns: [
      {
        title: "ลำดับ",
        dataIndex: "noTable",
        align: "center",
        render: (item, record, index) => <span>{index + 1}</span>,
      },
      {
        title: "ชื่อทุน",
        dataIndex: "studyScholarshipDetailName",
        align: "center",
        render: (item, record, index) => <span>{item ? item : "-"}</span>,
      },
      {
        title: "แหล่งเงินทุน",
        dataIndex: "studyScholarshipDetailSource",
        align: "center",
        render: (item, record, index) => <span>{item ? item : "-"}</span>,
      },
      {
        title: "จำนวนเงินที่อนุมัติ (บาท)",
        dataIndex: "studyScholarshipDetailBenefit",
        align: "center",
        render: (item, record, index) => (
          <span>{item ? numberWithCommas(item) : "-"}</span>
        ),
      },
    ],
  };

  async componentDidMount() {
    const { rawData } = this.props;
    if (rawData) {
      await this.setState({
        dataTableSholarship: rawData?.studyScholarshipDetails,
      });
    }
  }

  render() {
    const { match, rawData, isViewOnly } = this.props;
    const { loadingFullpage, columns, dataTableSholarship } = this.state;
    const { getFieldDecorator } = this.props.form;

    console.log("rawdata scholarship", rawData);
    console.log("rawdata scholarship detail", rawData.studyScholarshipDetails);
    return (
      <>
        <Row gutter={16} type="flex" justify="left" align="top" className="">
          <Col md={24} className="mb-3">
            <Text className="color-red">
              <span style={{ fontSize: "18px" }}>ข้อมูลทุน / สัญญา</span>
            </Text>
          </Col>

          <Col md={12} className="mb-2">
            <FromInput
              disabled={true}
              value={
                rawData?.studyScholarContractNo
                  ? rawData?.studyScholarContractNo
                  : "-"
              }
              //required={true}
              name={"leaveTypeName"}
              label="เลขที่สัญญา"
              mode={"text"}
            />
          </Col>

          <Col md={12} className="mb-2">
            <FromInput
              disabled={true}
              value={
                rawData?.studyScholarContractDate
                  ? changeFormatdate(rawData?.studyScholarContractDate)
                  : "-"
              }
              //required={true}
              name={"studyScholarContractDate"}
              label="วันที่ทำสัญญา"
              mode={"text"}
            />
          </Col>

          <Col md={24} className="mb-2 mt-2">
            <Form.Item className="mb-0" />
            <Table
              locale={{ emptyText: "ไม่พบข้อมูลรายการ" }}
              columns={columns}
              dataSource={dataTableSholarship}
              pagination={false}
              scroll={{ x: "max-content" }}
            />
          </Col>
          {/* <Col md={12} className="mb-2">
            <FromInput
              disabled={true}
              value={rawData?.studyScholarBenefit
                ?  numberWithCommas(this.props.rawData?.studyScholarBenefit)
                : "-"}
              //required={true}
              name={"studyScholarBenefit"}
              label="จำนวนเงินทั้งหมด (บาท)"
              mode={"text"}
            />
          </Col> */}
          <Col xs={24} md={24} align="right" style={{ textAlign: "right" }}>
            รวมยอดเงินที่เบิกได้จริง{" "}
            {numberWithCommas(this.props.rawData?.studyScholarBenefit)} บาท
          </Col>
        </Row>
      </>
    );
  }
}

WelfareListStudyPaymentInScholarshipDetail.defaultProps = {
  autoFocus: false,
};

WelfareListStudyPaymentInScholarshipDetail.propTypes = {
  afterSubmit: PropTypes.func,
  forgotLink: PropTypes.string,
  autoFocus: PropTypes.bool,
};

const WrappedWelfareListStudyPaymentInScholarshipDetail = Form.create()(
  WelfareListStudyPaymentInScholarshipDetail
);

export default withApollo(WrappedWelfareListStudyPaymentInScholarshipDetail);
